module.exports = __webpack_public_path__ + "static/media/services-bg-3.85e9d390.png";